/* eslint-disable react/jsx-key */
import React from "react";
import PropTypes from "prop-types";
import { money } from "~hooks/useHelpers";
import { getChartColor } from "./chartColors";

const GraficoClienteLegenda = ({ items, itemsOthers, title, tipo, escolha, total, filters }) => {
  const soma = (array) => {
    if (!array || !Array.isArray(array)) return 0;
    const divisor = array.slice(1).filter((num) => num > 0).length || 1;
    const soma = array.slice(1).reduce((acumulador, valor) => {
      return acumulador + valor;
    }, 0);
    const result = soma / divisor;
    return tipo === "linha" ? result : Number.parseFloat(result.toFixed(2));
  };

  const getTitleText = () => {
    if (tipo === "linha") {
      return escolha === "liquidos" ? "Fob. Líquido (R$/t)" : "Faturamento Médio";
    }
    return "Volume Médio";
  };

  const getTotalText = () => {
    if (tipo === "linha") {
      return escolha === "liquidos" ? "-" : money(total);
    }
    const formattedTotal = total.toFixed(2).replace(".", ",");
    const unit = escolha === "volumes" ? "t " : "t/DU ";
    return `${formattedTotal}${unit}/mês`;
  };

  const getItemValueText = (item) => {
    if (!item?.[escolha]) return "0,00";

    if (tipo === "linha") {
      const value = money(soma(item[escolha]));
      return escolha === "revenues" ? value : `${value}/t`;
    }
    return soma(item[escolha]).toFixed(2).replace(".", ",");
  };

  return (
    <div
      className={`${filters?.grupoMaterialId === 0 ? "px-8 pt-[52px]" : "px-8 pt-[87px]"}`}
      data-testid="grafico-legenda-container"
    >
      <div
        className="flex flex-col md:flex-row w-full items-center justify-between gap-2 bg-[#F2F2F2] p-2 rounded-md mt-[10px] pl-5"
        data-testid="legenda-header"
      >
        <p className="text-primaria text-xl font-bold" data-testid="legenda-title">
          {getTitleText()}
        </p>
        <span className="bg-terciaria rounded-md w-full md:w-auto text-center">
          <p className="text-white text-xl font-bold py-2 px-4" data-testid="legenda-total">
            {getTotalText()}
          </p>
        </span>
      </div>
      <div className="mt-8 grid grid-cols-2 gap-2" data-testid="legenda-items-grid">
        {(items || []).map((item, index) => (
          <div
            className="flex items-center gap-4 first:mt-0"
            key={`${item.id}-${item.name}`}
            data-testid={`legenda-item-${index}`}
          >
            <span
              className="w-5 h-5 rounded-full relative"
              data-testid={`color-indicator-${index}`}
              style={{
                backgroundColor: getChartColor(item),
                border: `${tipo === "barra" && filters?.grupoMaterialId !== 0 ? "2px solid #000000" : "none"}`,
                maxWidth: "20px",
                minWidth: "20px",
                height: "20px",
              }}
            >
              {tipo === "linha" && (
                <p
                  className="roteirizacao__line"
                  data-testid={`line-element-${index}`}
                  style={{
                    backgroundColor: getChartColor(item),
                  }}
                ></p>
              )}
            </span>

            <p className="text-primaria font-bold text-[12px]">
              {item.name}: {getItemValueText(item)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

GraficoClienteLegenda.propTypes = {
  items: PropTypes.array,
  itemsOthers: PropTypes.array,
  title: PropTypes.string,
  tipo: PropTypes.string,
  escolha: PropTypes.string,
  total: PropTypes.number,
  filters: PropTypes.shape({
    grupoMaterialId: PropTypes.number,
  }),
};

export default GraficoClienteLegenda;
